import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface CreateOperationInput {
  name: string;
  isDefault: boolean;
  priority: number;
}
export async function createOperation(input: CreateOperationInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
          mutation createOperation (
            $input: CreateOperationInput!
          ){
            createOperation(
                createOperationInput: $input
              )  
          }
          `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}

export async function getOperationsList(where: {} = {}) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                query getAllOperations($where:OperationsResolver_GetAllOperations_FilterInputType
                  ) {
                    getAllOperations (where:$where) {
                      id
                      name
                      isDefault
                      priority
                    }
                  }
                `,
      variables: { where },
    },
  });
  return data?.data?.data?.getAllOperations;
}

interface UpdateOperationInput {
  name: string;
  isDefault: boolean;
  priority: number;
}
export async function updateOperations(input: UpdateOperationInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            mutation updateOperation (
              $input: UpdateOperationInput!
            ){
                updateOperation(
                    updateOperationInput: $input
                ) 
            }
            `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}
